module.exports = __webpack_public_path__ + "media/application/images/svgs/help-circle-e44d1b53819ee02a2c960cbaced3550f.svg";